<div class="header">
  <span class="heading">{{ heading }}</span>

  <ng-container *ngTemplateOutlet="headerTemplate"> </ng-container>
</div>

<ng-content></ng-content>
